import { getVideoConstraints } from "src/modules/rtc/media-constraints";
import { getCameraAndMicrophoneInfo } from "../baby-station/BabyStation/media-devices";
const log = window.require("electron-log");

export async function getVideoStream() {
  let videoStream = null;

  const getWithCameraList = async () => {
    const { cameraId } = await getCameraAndMicrophoneInfo();
    videoStream = await navigator.mediaDevices.getUserMedia(
      getVideoConstraints({
        videoQuality: "HIGH",
        videoOptions: { deviceId: cameraId }
      }).constraints
    );
    if (!videoStream) throw new Error();
  };

  const getWithConstraints = async () => {
    videoStream = await navigator.mediaDevices.getUserMedia(
      getVideoConstraints({
        videoQuality: "HIGH"
      }).constraints
    );
    if (!videoStream) throw new Error();
  };

  const getWithBaseConstraints = async () => {
    videoStream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: true
    });
    if (!videoStream) throw new Error();
  };

  try {
    try {
      await getWithCameraList();
    } catch (err) {
      try {
        await getWithConstraints();
      } catch (err) {
        try {
          await getWithBaseConstraints();
        } catch (err) {
          log.error("Failed all video stream getters");
        }
      }
    }
    return videoStream;
  } catch (error) {
    log.error("cannot create videoStream");
    return null;
  }
}
